import type { PollConfig, PollType } from './types';

class PollRegistry {
  private configs: Map<PollType, PollConfig> = new Map();

  register<TData = unknown, TMeta = Record<string, unknown>>(
    config: PollConfig<TData, TMeta>
  ): void {
    this.configs.set(config.type, config as PollConfig);
  }

  get<TData = unknown, TMeta = Record<string, unknown>>(
    type: PollType
  ): PollConfig<TData, TMeta> | undefined {
    const config = this.configs.get(type) as
      | PollConfig<TData, TMeta>
      | undefined;
    return config;
  }

  has(type: PollType): boolean {
    return this.configs.has(type);
  }

  getAll(): PollConfig[] {
    return Array.from(this.configs.values());
  }

  getAllTypes(): PollType[] {
    return Array.from(this.configs.keys());
  }
}

export const pollRegistry = new PollRegistry();
